import { marqueeTags, siteInfo, statItems } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20theatrical%20stage%20filled%20with%20warm%20amber%20and%20deep%20green%20spotlights%20beaming%20through%20haze%2C%20dark%20moody%20cinematic%20texture%2C%20stylized%20no%20people%2C%20dramatic%20atmosphere&width=1600&height=900&seq=gs-hero-bg-01&orientation=landscape"
          alt="舞台灯光氛围背景，象征现场影像的沉浸感"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85"></div>
      </div>

      <div className="relative z-10 w-full min-h-[560px] md:min-h-[680px] flex flex-col items-center justify-center text-center px-4 md:px-8 pt-28 pb-16">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 border border-background-200/30 text-background-100 text-xs md:text-sm font-label backdrop-blur-sm mb-6">
          <i className="ri-fire-line text-accent-300" aria-hidden="true"></i>
          每日更新 · 热点影像资料库
        </span>

        <h1 className="font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight tracking-tight max-w-4xl">
          {siteInfo.name}
          <span className="block mt-3 text-xl md:text-3xl lg:text-4xl font-bold text-accent-300">
            娱乐热点影像资料，一网打尽
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
          {siteInfo.intro}
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full max-w-md sm:max-w-none sm:w-auto">
          <a
            href="#collections"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-accent-500 text-background-50 text-sm md:text-base font-label font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg" aria-hidden="true"></i>
            浏览热门合集
          </a>
          <a
            href="#highlights"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-background-50/10 border border-background-200/40 text-background-50 text-sm md:text-base font-label font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            了解内容类型
            <i className="ri-arrow-down-line text-lg" aria-hidden="true"></i>
          </a>
        </div>

        <dl className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-7 w-full max-w-4xl">
          {statItems.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <dt className="order-2 mt-1.5 text-xs md:text-sm text-background-300">{stat.label}</dt>
              <dd className="order-1 font-heading font-bold text-2xl md:text-3xl text-background-50">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative z-10 w-full bg-primary-950/85 border-t border-primary-800 py-3 overflow-hidden">
        <div className="flex w-max animate-marquee">
          {[...marqueeTags, ...marqueeTags].map((tag, index) => (
            <span
              key={`${tag}-${index}`}
              className="flex items-center gap-3 px-5 text-xs md:text-sm text-background-300 font-label whitespace-nowrap"
            >
              <i className="ri-circle-fill text-[6px] text-accent-400" aria-hidden="true"></i>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}